<div class="d-flex flex-column align-items-center">
  <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[700px]">
    <div class="d-flex flex-column align-items-end" (click)="close()"> <span style="cursor: pointer;">&times;</span></div>
    <h5>Are you sure?</h5>
    <div class="d-flex justify-content-between mt-4">
      <input class="btn btn-primary" type="button" value="YES" (click)="yesClicked()"/>
      <input class="btn btn-danger" type="button" value="NO" (click)="noClicked()"/>
    </div>      
  </div>
</div>